import { j as r } from "../../../_virtual/jsx-runtime.js";
import i from "../../atoms/BaseCard/index.js";
import c from "../../atoms/BaseCardHeader/index.js";
import f from "../../atoms/Icon/index.js";
import l from "../../atoms/MetricDisplay/index.js";
import { cn as x } from "../../../lib/utils.js";
const h = ({
  metricHeader: o,
  metricDisplay: e,
  className: m,
  background: a,
  isLoading: s
}) => {
  const { iconProps: t, ...p } = o;
  return /* @__PURE__ */ r.jsxs(
    i,
    {
      className: x("p-3 flex flex-col gap-4 mt-3 mb-6", m),
      background: a,
      children: [
        /* @__PURE__ */ r.jsx(c, { isLoading: s, size: "sm", ...p, children: /* @__PURE__ */ r.jsx(f, { ...t }) }),
        /* @__PURE__ */ r.jsx(l, { isLoading: s, ...e })
      ]
    }
  );
};
export {
  h as default
};
